export default __webpack_public_path__ + "static/media/content_tab03_2_01.87f5b261.png";